import DepositPayment from '@/components/page/DepositPayment';
import React from 'react';

const DepositPaymentPage: React.FC<any> = () => {
  return <DepositPayment />;
};
export default DepositPaymentPage;
